import gql from 'graphql-tag'

export const eventCodeUnassignCoreCause = gql`
  mutation eventCodeUnassignCoreCause($eventCodeId: ID!, $coreCauseId: ID!) {
    eventCodeUnassignCoreCause(input: { eventCodeId: $eventCodeId, coreCauseId: $coreCauseId }) {
      success
    }
  }
`
